module.exports = __webpack_public_path__ + "static/media/blue4.864a6b9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/blue4.svg
// module id = 1331
// module chunks = 31